export const USER_JWT_TOKEN = 'departmentJwtToken';
export const CURR_LOCALE = 'CurrentLocale';
